import { useState, useEffect } from 'react';
import { Link, useParams } from "react-router-dom"
import axios from '../api/axios';


const VerifyEmail = () => {

	const [isVerified, setIsVerified] = useState(undefined);

	const { requestId, requestToken } = useParams();
	// console.log(`requestId: ${requestId} requestToken: ${requestToken}`);

	function VerificationStatus ({verified}) {
		// console.log(`VerificationStatus verified: ${verified}`);
		// console.log(verified);
		if (verified === undefined) {
			return <p>One moment please&hellip;</p>
		} else if (verified) {
			return(
				<>
					<p>Thank you for verifying your email address!</p>
					<p><Link to="/login">Log in</Link></p>
				</>
			)
		} else {
			return(
				<>
					<p>This link is either expired or invalid.</p>
					<p><Link to="/verification">Request a new link</Link> or <Link to="/register">Sign Up</Link></p>
				</>
			)
		}
	}

	useEffect(() => {

		let ignore = false;

        const verifyEmail = async () => {
            try {
                // const response = await axios.get(`/validate/${requestId}/${requestToken}`);
				const response = await axios.post("/validate",
					JSON.stringify({ requestId, requestToken }),
					{
						headers: { 'Content-Type': 'application/json' }
					}
				);
				if (!ignore) {
					const verified = response?.data?.verified;
					setIsVerified(verified);
				}
            } catch (err) {
                console.error(err);
            }
        }
		
		verifyEmail();

		return () => {
			ignore = true;
		};		

	}, [requestId, requestToken]);

    return (
        <section>
            <h1>Verify email</h1>
			<VerificationStatus verified={isVerified}/>
        </section>
    )
}

export default VerifyEmail